import ThinkingDataSDK from '@ssr/components/Analytics/ThinkingDataSdk'
import VolcEngine from '@ssr/components/Analytics/VolcEngine'
import React from 'react'

import PointsApi from '../../common/api'
import { tooltip } from '../../common/Modal'

import Interceptor, { isGuest } from '../../common/Interceptor'
import usePageStore, { PageStore } from '../context'

import styles from './index.module.less'
import './index.less'
import { CommonContext } from '@ssr/context'
import { commonTracking } from '@ssr/lib/utils'

const icPlus = 'https://static.insta360.com/assets/www/project/official/activity/points_lotto/plus_1.png'
const icMinus = 'https://static.insta360.com/assets/www/project/official/activity/points_lotto/reduce_1.png'

function formatedText(str, num) {
  let nextStr = str || ''

  if (window.isOversea && num <= 1) {
    nextStr = nextStr.replace('opportunities', 'opportunity')
  }

  return nextStr
}

function calculateDiffTime(start_time, end_time) {
  var usedTime = end_time - start_time
  if (usedTime < 0) {
    usedTime = 0
  }

  var days = Math.floor(usedTime / (24 * 3600 * 1000))
  var leave1 = usedTime % (24 * 3600 * 1000)
  var hours = Math.floor(leave1 / (3600 * 1000)) + days * 24
  var leave2 = leave1 % (3600 * 1000)
  var minutes = Math.floor(leave2 / (60 * 1000))
  var leave3 = leave2 % (60 * 1000)
  var second = Math.floor(leave3 / 1000)

  var timeStrArr = [hours, minutes, second]
  timeStrArr.forEach((v, index) => {
    if (timeStrArr[index] < 10) {
      timeStrArr[index] = '0' + timeStrArr[index]
    }
  })

  return timeStrArr
}

class Countdown extends React.Component {
  shouldComponentUpdate() {
    return false
  }

  componentDidMount() {
    const hr = this.refs.hr
    const min = this.refs.min
    const sec = this.refs.sec

    this.interval = setInterval(() => {
      const arr = calculateDiffTime(new Date().getTime(), this.props.targetTimestamp)

      hr.textContent = arr[0]
      min.textContent = arr[1]
      sec.textContent = arr[2]
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const { isOversea, __ } = this.props
    return (
      <div className={[styles.countdown, isOversea ? styles.oversea : ''].join(' ')}>
        {isOversea ? <div className={styles.text}>{__['app.points.lottery.countdown']}</div> : <div className={styles.text}>{__['app.points.lottery.countdown_t1']}</div>}

        <div className={styles.boards}>
          <div className={styles.board}>
            <span ref='hr'>00</span>
            {isOversea ? <span className={styles.label}>H</span> : null}
          </div>
          <div className={styles.colon}>:</div>
          <div className={styles.board}>
            <span ref='min'>00</span>
            {isOversea ? <span className={styles.label}>M</span> : null}
          </div>
          <div className={styles.colon}>:</div>
          <div className={styles.board}>
            <span ref='sec'>00</span>
            {isOversea ? <span className={styles.label}>S</span> : null}
          </div>
        </div>
        {isOversea ? null : <div className={styles.text}>{__['app.points.lottery.countdown_t2']}</div>}
      </div>
    )
  }
}

class ModalVote extends React.Component {
  state = {
    visible: false,
    points: 10,

    loading: false,

    error: false,
    errorText: '',
  }

  show = (product, point_pool_remain) => {
    const user_points_remain = PageStore.getState().totalPoints
    this.product = product
    this.point_pool_remain = point_pool_remain
    this.user_points_remain = user_points_remain

    this.setState({ visible: true })
    this.setPoints(10)
  }

  plus = () => {
    this.setPoints(this.state.points + 1)
  }

  minus = () => {
    this.setPoints(this.state.points - 1 >= 0 ? this.state.points - 1 : 0)
  }

  input = (v) => {
    this.setPoints(v.replace(/[^\d]/g, '') - 0)
  }

  setPoints = (points) => {
    this.setState({ points })

    if (this.user_points_remain <= 0) {
      return this.setState({
        error: true,
        errorText: __['app.points.lottery.error_not_enough'],
      })
    }

    if (points <= 0 || points > this.user_points_remain) {
      return this.setState({
        error: true,
        errorText: __['app.points.lottery.error_min'],
      })
    }

    if (points > 500) {
      return this.setState({
        error: true,
        errorText: __['app.points.lottery.error_activity_max'],
      })
    }

    if (points > this.point_pool_remain) {
      return this.setState({
        error: true,
        errorText: __['app.points.lottery.error_pool_max'],
      })
    }

    this.setState({
      error: false,
      errorText: '',
    })
  }

  onOk = () => {
    this.setState({ loading: true })
    PointsApi.lotteryJoin({
      product_id: this.product.id,
      points: this.state.points,
    }).then((res) => {
      if (res.data && res.data.success) {
        const remainTimes = res.data.remain_times
        const successText1 = __['app.points.lottery.success_t1']
        const successText2 = formatedText(__['app.points.lottery.success_t2'], remainTimes)

        // 提交数数科技统计
        commonTracking('success_credits_lotto', {
          credits: this.user_points_remain - this.state.points,
          credit_used: this.state.points,
          goods_id: this.product.id,
          goods_name: this.product.info?.name,
        })

        this.onCancel()
        tooltip({ content: `${successText1} ${remainTimes} ${successText2}` })

        // 刷新列表，刷新当前操作的这个项目状态的列表
        const getProductList = PageStore.getState().getProductList
        if (['init', 'already_lottery'].includes(this.product.status)) {
          getProductList('processing', true)
        } else {
          getProductList(this.product.status, true)
        }
      } else {
        this.onCancel()
        tooltip({ content: __['app.points.lottery.fail'] })
      }

      this.setState({ loading: false })
    })
  }

  onCancel = () => {
    this.setState({ visible: false })
  }

  render() {
    const { visible, points, loading, error, errorText } = this.state
    const { __, locale, isOversea } = this.props
    return (
      <div className={styles.modal_mask} style={{ display: visible ? 'block' : 'none' }}>
        <div className={styles.modal}>
          <div className={styles.text}>{__['app.points.lottery.modal_title']}</div>
          <div className={styles.input_vote}>
            <div className={styles.ic_minus} onClick={this.minus}>
              <img src={icMinus} alt='' />
            </div>
            <input
              type='text'
              value={points}
              onChange={(e) => {
                this.input(e.target.value)
              }}
            />
            <div className={styles.ic_plus} onClick={this.plus}>
              <img src={icPlus} alt='' />
            </div>
          </div>

          {error ? <div className={styles.text_error}>{errorText}</div> : null}

          <div className={styles.btn_list}>
            <button className={styles.btn} disabled={loading || error} onClick={this.onOk}>
              {__['app.points.lottery.modal_confirm']}
            </button>
            <button className={styles.btn_cancel} disabled={loading} onClick={this.onCancel}>
              {__['app.points.lottery.modal_cancel']}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

class Main extends React.Component {
  state = {
    ruleShowMore: false,
    productListType: 'processing',
  }

  setProductListType = (type) => {
    const { productListType } = this.state

    if (productListType === type) return

    this.setState({ productListType: type })
  }

  tryJoin = (product, pointPoolRemain) => {
    if (isGuest({ showTooltip: true })) return
    this.refs.modalVote.show(product, pointPoolRemain)
  }

  render() {
    const { ruleShowMore, productListType } = this.state
    const { __, locale, isOversea } = this.props
    const imgBanner = isOversea
      ? 'https://res.insta360.com/static/assets/storage/20210112/1450ffba00e61cb58337ef551022071e/lottery_en.png'
      : 'https://res.insta360.com/static/assets/storage/20210112/f516b8992917d2bd7900b298053f8d01/lottery_ch.png'
    return (
      <div>
        <div className={styles.main_banner}>
          <img src={imgBanner} alt='' />
        </div>

        <div className={styles.block}>
          <Account />

          <div className={styles.rule}>
            <div className={styles.text}>{__['app.points.lottery.rule_title']}</div>
            <div className={styles.text_sm} style={{ height: ruleShowMore ? 'auto' : '60px' }} dangerouslySetInnerHTML={{ __html: __['app.points.lottery.rule_desc'] }}></div>

            <div className={styles.btn_list}>
              <div
                className={styles.view_more}
                onClick={() => {
                  this.setState({ ruleShowMore: !ruleShowMore })
                }}>
                {ruleShowMore ? __['app.points.lottery.hide'] : __['app.points.lottery.display_all']}
              </div>
            </div>
          </div>

          <div className={styles.nav}>
            <div
              className={[styles.nav_item, productListType === 'processing' ? styles.active : ''].join(' ')}
              onClick={() => {
                this.setProductListType('processing')
              }}>
              {__['app.points.lottery.nav_running']}
            </div>
            <div
              className={[styles.nav_item, productListType === 'next' ? styles.active : ''].join(' ')}
              onClick={() => {
                this.setProductListType('next')
              }}>
              {__['app.points.lottery.nav_next']}
            </div>
            <div
              className={[styles.nav_item, productListType === 'over' ? styles.active : ''].join(' ')}
              onClick={() => {
                this.setProductListType('over')
              }}>
              {__['app.points.lottery.nav_over']}
            </div>
          </div>

          {productListType === 'processing' && <ProductList type='processing' tryJoin={this.tryJoin} />}
          {productListType === 'next' && <ProductList type='next' tryJoin={this.tryJoin} />}
          {productListType === 'over' && <ProductList type='over' tryJoin={this.tryJoin} />}
        </div>

        <ModalVote __={__} locale={locale} isOversea={isOversea} ref='modalVote' />
      </div>
    )
  }
}

// 项目列表
function ProductList({ type, tryJoin }) {
  const { __, isOversea } = React.useContext(CommonContext)
  const tagWin = isOversea
    ? 'https://res.insta360.com/static/assets/storage/20210105/8322de7e9b26f02d428954287aaa03e6/tag_en.png'
    : 'https://res.insta360.com/static/assets/storage/20210105/e7f5b30471aaab592887240c3205e992/tag_ch.png'
  const product = usePageStore((state) => state.productList[type])
  const productListJoinedMap = usePageStore((state) => state.productListJoinedMap)
  const getProductList = usePageStore((state) => state.getProductList)
  if (!product) return null

  const ref = React.useRef(null)

  React.useEffect(() => {
    const onScroll = () => {
      if (window.scrollY + window.innerHeight > ref.current.offsetTop) {
        getProductList(type)
      }
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const listStatus = React.useMemo(() => {
    if (product.loading) return 'loading'
    if (product.currentPageNumber >= product.totalPage) return 'noMore'
    return 'normal'
  }, [product])

  return (
    <div className={styles.product_list}>
      {product.list.map((item) => {
        const info = item.info || {}
        const pointPoolRemain = item.point_total - item.point_pool
        const winLottery = type === 'over' && productListJoinedMap.get(item.id)?.status === 'win_lottery'

        return (
          <div className={styles.product} key={item.id}>
            <div className={[styles.cover, winLottery ? styles.win : ''].join(' ')}>
              <img className={styles.img} src={item.picture_url} alt='' />
              <img className={styles.tag} src={tagWin} alt='' />
            </div>

            <div className={styles.detail}>
              <div className={styles.text}>{info.name}</div>
              <div className={styles.text_sm}>{info.description}</div>

              {type === 'processing' ? (
                <div className={styles.progress}>
                  <div className={styles.progress_bar}>
                    <div className={styles.progress_current} style={{ width: (item.point_pool / item.point_total) * 100 + '%' }}></div>
                  </div>

                  <div className={styles.progress_text}>
                    <div className={styles.left}>
                      {item.point_pool}/{item.point_total}
                    </div>
                    <div className={styles.right}>
                      {__['app.points.lottery.join_points_t1']} {item.user_points} {__['app.points.lottery.join_points_t2']}
                    </div>
                  </div>
                </div>
              ) : null}

              {type === 'over' && item.nickname ? (
                <div className={styles.winner}>
                  {__['app.points.lottery.winner']}
                  {item.nickname}
                </div>
              ) : null}

              {type === 'next' ? <button className={styles.btn_large}>{__['app.points.lottery.coming_soon']}</button> : null}

              {type === 'over' ? <button className={[styles.btn_large, styles.over].join(' ')}>{__['app.points.lottery.status_ended']}</button> : null}

              {type === 'processing' ? (
                <div className={styles.panel_vote}>
                  <Countdown __={__} isOversea={isOversea} locale={locale} targetTimestamp={item.finish_time} />

                  {item.status === 'already_lottery' ? (
                    <button className={styles.btn} disabled>
                      {__['app.points.lottery.joined']}
                    </button>
                  ) : (
                    <button
                      className={styles.btn}
                      onClick={() => {
                        tryJoin(item, pointPoolRemain)
                      }}>
                      {__['app.points.lottery.join_now']}
                    </button>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        )
      })}

      <div ref={ref} className={styles.bottomBlock}>
        {listStatus === 'normal' && <span className={styles.text}>{__['app.points.lottery.tip_more']}</span>}
        {listStatus === 'loading' && <img className={styles.icon} src='https://res.insta360.com/static/d53ae3584d071f2b888fb9a98ec34b74/icon-loading.png' alt='' />}
        {listStatus === 'loading' && <span className={styles.text}>{__['app.points.lottery.tip_loading']}</span>}
        {listStatus === 'noMore' && <span className={styles.text}>{__['app.points.lottery.tip_no_more']}</span>}
      </div>
    </div>
  )
}

// 用户积分
function Account() {
  const { __ } = React.useContext(CommonContext)
  const totalPoints = usePageStore((state) => state.totalPoints)

  return (
    <div className={styles.account}>
      <div className={styles.text}>{__['app.points.common.my_points']}</div>
      <div className={styles.text_sm}>{totalPoints}</div>
      <a href='/app/points_lottery/mine' className={styles.link}>
        {__['app.points.lottery.my_lottery']}
      </a>
    </div>
  )
}

// 页面包装及数据初始化
function Page() {
  const { __, isOversea, locale } = React.useContext(CommonContext)
  const gerTotalPoint = usePageStore((state) => state.gerTotalPoint)
  const getProductList = usePageStore((state) => state.getProductList)
  const getProductListJoined = usePageStore((state) => state.getProductListJoined)
  React.useEffect(() => {
    getProductList('processing')
    getProductList('next')
    getProductList('over')
    if (isGuest()) {
      commonTracking('enter_credits_lotto', { credits: null })
    } else {
      gerTotalPoint().then((total_points) => {
        commonTracking('enter_credits_lotto', { credits: total_points })
      })
      getProductListJoined()
    }
  }, [])

  return (
    <>
      <Interceptor>
        <Main __={__} isOversea={isOversea} locale={locale} />
      </Interceptor>
      <ThinkingDataSDK />
      <VolcEngine />
    </>
  )
}

Page.injectData = function ({ locals }) {
  return {
    localeData: {
      namespaces: ['common', 'app'],
    },
  }
}

export default Page
